import { render, staticRenderFns } from "./CrossSell.vue?vue&type=template&id=0898473b&scoped=true&"
import script from "./CrossSell.vue?vue&type=script&lang=js&"
export * from "./CrossSell.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./CrossSell.vue?vue&type=style&index=0&id=0898473b&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0898473b",
  null
  ,true
)

export default component.exports